import { Router } from '@angular/router';
import { UsuarioOnline } from './../entities/UsuarioOnline.entity';
import { ResetPassword } from './../entities/resetPassword.entity';
import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { SessionService } from '../services/session.service';
import { Explotacion } from '../entities/explotacion.entity';
import { Respuesta } from '../entities/respuesta.entity';
import { validate, ValidationError } from 'class-validator';
import { environment } from '../../environments/environment';
import { AlertBoxComponent } from '../shared/alertbox.component';

export interface FormModel { captcha?: string; }

@Component({
  selector: 'app-resetPassword',
  templateUrl: './resetPassword.component.html'
})
export class ResetPasswordComponent implements OnInit {
  public explotaciones: Explotacion[];
  public user: ResetPassword = new ResetPassword();
  public resultado: Respuesta;
  public messageCabecera: string;
  public typeException: number;
  public messageComplet: string;
  public poblacion: number;
  public login: string;
  public poblacionInputError: boolean;
  public loginInputError: string;
  public userOnline: UsuarioOnline;
  public formModel: FormModel = {};
  public captchaError: boolean;
  public keyCapchasite: string;

  constructor(private userService: UserService, private sessionService: SessionService, private router: Router) { }

  ngOnInit() {
    this.poblacion = -1;
    this.sessionService.datosExplotacion = new Explotacion();
    this.sessionService.datosExplotacion.CondicionesEnvio = null;
    this.explotaciones = this.sessionService.Explotaciones;
    if (this.explotaciones !== undefined && this.explotaciones.length === 1) {
      this.poblacion = 0;
      this.CambioPoblacion();
    } else
      this.router.navigate(['/public/login']);
    this.keyCapchasite = environment.capchasiteKey;
  }

  public resetPassword($event): void {
    this.user.gRecaptchaResponse = this.formModel.captcha;
    this.formModel.captcha = this.formModel.captcha === undefined ? null : this.formModel.captcha;
    this.user.Login = this.login;
    if (this.poblacion !== -1) {
      this.user.Poblacion = this.explotaciones[this.poblacion].Codigo;
    } else {
      this.user.Poblacion = null;
    }
    validate(this.user).then(resultado => {
      if (resultado.length > 0 || this.formModel.captcha === null) {
        this.clearInputErrors();
        this.showErrors(resultado);
      } else {
        this.userService.resetPassword(this.user)
          .then(
            response => this.resetPasswordOnSuccess(response),
            response => this.resetPasswordOnError(response)
          );
      }
    });
  }

  private resetPasswordOnSuccess(response): void {
    this.clearInputErrors();
    this.clearInputs();
    this.showMessage();
  }

  private resetPasswordOnError(response): void {
    this.formModel.captcha = null;
    this.resultado = response;
    if (this.resultado.Ex !== undefined) {
      this.messageCabecera = 'Error en solicitud de nueva clave';
      this.messageComplet = this.resultado.Ex.Message;
      this.typeException = this.resultado.TipoExcepcion;
    } else {
      this.clearInputErrors();
      this.clearInputs();
      this.showMessage();
    }
  }

  private showMessage() {
    this.messageCabecera = 'Solicitud de nueva contraseña enviada';
    this.messageComplet = 'Si los datos introducidos son correctos, en breve recibira un e-mail.';
    this.typeException = 2;
    AlertBoxComponent.changeMensaje.next(this.typeException);
  }

  public CambioPoblacion() {
    if (this.poblacion !== -1) {
      this.sessionService.datosExplotacion = this.explotaciones[this.poblacion];
    } else {
      this.sessionService.datosExplotacion = new Explotacion();
      this.sessionService.datosExplotacion.CondicionesEnvio = null;
    }
  }

  private clearInputErrors() {
    if (this.poblacionInputError) {
      this.poblacionInputError = false;
    }
    this.loginInputError = '';
    if (this.captchaError) {
      this.captchaError = false;
    }
  }

  private clearInputs() {
    this.poblacion = -1;
    this.login = '';
  }

  private showErrors(resultado: ValidationError[]) {
    for (let item of resultado) {
      switch (item.property) {
        case 'Login':
          this.loginInputError = 'Introduzca un DNI válido';
          break;
        case 'Poblacion':
          this.poblacionInputError = true;
          break;
      }
    }
    if (this.formModel.captcha === null) {
      this.captchaError = true;
    }
  }

}
